// Wrapper typé pour pousser des events de conversion dans le dataLayer
// GTM. Chaque event inclut automatiquement les params UTM de la session
// pour permettre l'attribution.
//
// Convention de naming : snake_case, verbe au passé (ex: "menu_viewed",
// "reservation_completed") — compatible Meta Pixel + GA4 standard events.

import { getUtm } from './utm';

// Liste des events trackés dans l'app — extensible. TypeScript force à
// utiliser un nom déjà déclaré, évite les typos qui cassent les rapports
// GTM.
export type TrackEventName =
  // Engagement
  | 'page_view'
  | 'chatbot_opened'
  | 'chatbot_message_sent'
  // Pages publiques
  | 'menu_viewed'
  | 'cocktail_viewed'
  | 'tasting_item_viewed'
  | 'food_viewed'
  | 'event_viewed'
  // Conversions
  | 'reservation_started'
  | 'reservation_completed'
  | 'event_registration_started'
  | 'event_registration_completed'
  | 'job_viewed'
  | 'job_video_played'
  | 'job_application_started'
  | 'job_application_submitted'
  // Outbound
  | 'cta_click';

export type TrackParams = Record<string, string | number | boolean | undefined>;

export function track(event: TrackEventName, params: TrackParams = {}): void {
  if (typeof window === 'undefined') return;
  if (!window.dataLayer) window.dataLayer = [];

  // Nettoie les undefined pour pas polluer le dataLayer
  const clean: TrackParams = {};
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) clean[key] = value;
  }

  window.dataLayer.push({
    event,
    ...getUtm(),
    ...clean,
  });
}
